<script>
import agreementStats from '@/utils/agreementStats';

import FormBlock from '@/components/FormBlock.vue';
import StatisticTile from '@/components/ui/StatisticTile.vue';


export default {
  name: 'AgreementStatTiles',
  components: { FormBlock, StatisticTile },
  props: {
    items: Array,
  },
  computed: {
    stats() { return agreementStats.getStats(this.items); },
    titles() { return agreementStats.getTitles(); },
  },
}
</script>

<template lang="pug">
  FormBlock.b-agreement-stat-tiles(mobile)
    ._title Статистика согласований
    ._statistics
      StatisticTile(
        v-for="key in Object.keys(titles)"
        :key="titles[key].title"
        v-bind="titles[key]"
        :value="stats[key]"
      )
      ._stat-desc В статистике учитываются только рабочие дни календаря по московскому часовому поясу
</template>

<style scoped lang="scss">
.agreement-stat-tiles {


  &__stat-desc {
    font-size: 11px;
    padding: 20px 16px;
    border-radius: 8px;
    font-weight: 400;
    color: #1E3147;
    background: #E1F0FE;
  }

  &__title {
    font-size: 18px;
    margin-bottom: 12px;
  }

  &__stats-wrap {
    align-self: start;
  }

  &__statistics {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 23px;
  }

  @media (max-width: 1350px) {
    &__statistics {
      grid-template-columns: 1fr 1fr;
      gap: 10px;
    }
  }

  @media (max-width: 900px) {
    &__statistics {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 576px) {
    &__statistics {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 400px) {
    &__statistics {
      grid-template-columns: 1fr;
    }
  }
}
</style>
